/**
 * King Living Tag Theme
 *
 * Global tag styling system supporting:
 * - 2 sizes: large (big) and small
 * - Multiple variants: sale, new, out-of-stock, in-stock, low-stock, order-confirmed, delivered, most-popular
 * - Consistent typography and spacing
 *
 * @override Extends Chakra UI Tag theme
 */

const Tag = {
  parts: ['container', 'label'],
  baseStyle: {
    container: {
      display: 'flex',
      alignItems: 'center',
      gap: 2, // 8px
      borderRadius: 'base', // 4px
      fontSize: 'xs', // 12px
      fontFamily: 'body',
      fontWeight: '600', // SemiBold
      lineHeight: '120%', // 1.2
      fontStyle: 'normal',
      whiteSpace: 'nowrap',
    },
    label: {
      fontSize: 'xs', // 12px
      fontFamily: 'body',
      fontWeight: '600', // SemiBold
      lineHeight: '120%', // 1.2
      fontStyle: 'normal',
    },
  },
  sizes: {
    large: {
      container: {
        px: 2, // 8px
        py: 1, // 4px
      },
    },
    small: {
      container: {
        px: 1.5, // 6px
        py: 0.5, // 2px
      },
    },
  },
  variants: {
    'sale': {
      container: {
        bg: '#cd2a2d', // Sale red from Figma
        color: 'white',
      },
    },
    'new': {
      container: {
        bg: 'brandColors.greyscale90', // rgba(27, 26, 24, 0.9)
        color: 'white',
      },
    },
    'out-of-stock': {
      container: {
        bg: 'brandColors.error', // #9d2a1e
        color: 'white',
      },
    },
    'in-stock': {
      container: {
        bg: 'brandColors.success', // #2d7831
        color: 'white',
      },
    },
    'low-stock': {
      container: {
        bg: 'brandColors.warning', // #d97706
        color: 'white',
      },
    },
    'order-confirmed': {
      container: {
        bg: 'brandColors.primaryDarkLinen', // #8c683b
        color: 'white',
      },
    },
    'delivered': {
      container: {
        bg: 'white',
        color: 'brandColors.primaryDarkLinen', // #8c683b
      },
    },
    'most-popular': {
      container: {
        bg: 'brandColors.greyscale90', // rgba(27, 26, 24, 0.9)
        color: 'white',
      },
    },
  },
  defaultProps: {
    size: 'large',
    variant: 'new',
  },
};

export default Tag;
